export default {
  getAllAlerts: (state) => {
    return state.alerts
  },
  getRestId: (state) => {
    return state.restId
  },
  get_pmb_complete: (state) => {
    return state.alerts.pmb.complete
  },
  get_pmb_pending: (state) => {
    return state.alerts.pmb.pending
  },
  get_cc_complete: (state) => {
    return state.alerts.cc.complete
  },
  get_cc_pending: (state) => {
    return state.alerts.cc.pending
  },
  get_d_complete: (state) => {
    return state.alerts.d.complete
  },
  get_d_pending: (state) => {
    return state.alerts.d.pending
  },
  get_oa_complete: (state) => {
    return state.alerts.oa.complete
  },
  get_oa_pending: (state) => {
    return state.alerts.oa.pending
  }

}



// WEBPACK FOOTER //
// ./src/store/alerts/getters.js